module.exports = __webpack_public_path__ + "img/DE04097.f463d961.png";